// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36HCs","left":"styles_left__2CiN2"};